import { render, staticRenderFns } from "./LMUApprovalForm.vue?vue&type=template&id=8e0260ca&"
import script from "./LMUApprovalForm.vue?vue&type=script&lang=js&"
export * from "./LMUApprovalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports